export const transformErrorResponse = (error: any) => {
    console.error(error)
    const message = error.data?.messageSigo
        ? error.data?.messageSigo
        : '¡Ocurrió un error inesperado!'
    return { message }
}